import React from 'react';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className='hero_header'>
        <div className='Header_left'/>
        <img src="./logo.png" alt="logo" className='Header_rigth' />
      </div>
      <div className="hero-content">
        <h1>¡DESCUBRIENDO EL MUNDO CON ESCAPES DE LUJO.COM!</h1>
        <p>¡Viaja a destinos de ensueño a precios irresistibles!</p>
      </div>
    </section>
  );
}

export default Hero;
